module.exports = __webpack_public_path__ + "img/hr.9b7fd1f4.svg";